import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import styles from "./HoverImage.module.scss";
import { CardComponentProps } from "@~/types/types";
import { PDPLink } from "../__shared__/PDPLink/PDPLink";
import { isM2MFabricProduct } from "../__shared__/PDPLink/components/M2MProductSelector/utils";
import { modifyImageUrlQueryParams } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { Image } from "../__shared__/Image/Image";

export const HoverImage = ({
  index,
  product,
}: Pick<CardComponentProps, "index" | "product">) => {
  const { variant } = useVariant();
  const isM2MProduct = isM2MFabricProduct(product);

  const primaryImgUrl = variant?.images.primary.split("?")[0];
  const altImgUrl = variant?.images.alternatives[0]?.split("?")[0];

  if (!primaryImgUrl) {
    return null;
  }

  const containerClass = isM2MProduct
    ? styles.buttonContainer
    : styles.container;

  const imageContent = (
    <>
      <Image
        url={primaryImgUrl}
        title={product.title}
        colour={variant?.colour?.colour || ""}
        index={index}
      />

      {altImgUrl && (
        <Image
          url={altImgUrl}
          title={product.title}
          colour={variant?.colour?.colour || ""}
          index={index}
          testId="product-alt-image"
          className={styles.altImage}
          loading="lazy"
        />
      )}
    </>
  );

  return (
    <PDPLink
      product={product}
      className={containerClass}
      componentName="HoverImage"
      tabIndex={-1}
      ariaHidden
    >
      {imageContent}
    </PDPLink>
  );
};
